<template>
    <layout>
        <div class="is-user-dashboard" v-if="!isGrantedBookKeeper">
            <div>
                <orders
                    ref="ordersComponent"
                    v-on:refreshTodos="refreshTodos"
                    v-on:openTagsForm="$refs.tagsForm.openWithRow($event)"
                />
                <!-- Same collapsible rail as the ClientPortal, so folding the
                     deadlines away to give the order table the width works the
                     same on both sides. -->
                <collapsible-rail
                    class="is-hidden-mobile is-hidden-tablet-only"
                    storage-key="userDashboardTodosCollapsed"
                >
                    <todos ref="todosComponent" />
                </collapsible-rail>
            </div>
            <tour />
            <tags-form ref="tagsForm" @saved="$refs.ordersComponent.refreshTable()" />
        </div>
    </layout>
</template>

<script>
import Todos from './Todos';
import Orders from './Orders';
import Tour from './Tour'
import Modal from '@components/Modal';
import CollapsibleRail from '@components/CollapsibleRail';
import TagsForm from '@orders/dashboard/TagsForm';
import {currentUser} from "@utilities/functions";

export default {
    components: {
        Modal,
        CollapsibleRail,
        Todos,
        Orders,
        Tour,
        TagsForm
    },

    computed: {
        isGrantedBookKeeper: function() {
            let loggedInUser = currentUser();
            return loggedInUser && loggedInUser.roles && loggedInUser.roles.includes('ROLE_BOOK_KEEPER');
        },
    },

    methods: {
        refreshTodos: function(){
            // The rail removes its content when collapsed, so the component may not
            // exist. Nothing to refresh then — it fetches on mount when reopened.
            if (this.$refs.todosComponent) {
                this.$refs.todosComponent.fetchTodos();
            }
        }
    },

    created () {
        if(this.isGrantedBookKeeper) {
            window.location.replace(`/invoices`);
        }
    }
}
</script>
